import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { bind } from '../../util/react'
import TagDropdown from './tag-dropdown'

import styles from './tag-group.module.css'

const propTypes = {
    isOpen: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired
}

const defaultProps = {
    isOpen: false,
    onClick: () => {}
}

/**
 * Tag group is the actual wrapper for tags that is responsible for the dropdown and collecting logic.
 *
 * Usage:
 *
 * @example
 * <TagGroup title={'tags'} isOpen={false} onClick={() => { doSomething() }}>
 *     <Tag ...>
 * </TagGroup>
 *
 * @property {string} props.title         - The group name to show.
 * @property {Object} [props.isOpen]      - Show the group dropdown as open.
 * @property {function} [props.onClick]   - Callback that gets fired, when the  group is clicked.
 */
class TagGroup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: props.isOpen
        }
        bind(this)
    }

    UNSAFE_componentWillMount() {
        document.addEventListener('click', this.handleClick, false)
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false)
    }

    render() {
        const { children, title } = this.props
        const { isOpen } = this.state

        return (
            <div className={styles['group']}>
                <div className={styles['group-title']}>
                    <div className={styles['group-counter']}>{children.length}</div>
                    {title}
                </div>
                <TagDropdown ref={ref => (this.dropdown = ref)} isOpen={isOpen}>
                    {children}
                </TagDropdown>
            </div>
        )
    }

    handleClick(event) {
        const { onClick } = this.props
        const { isOpen } = this.state
        const dropdown = ReactDOM.findDOMNode(this.dropdown)

        if (dropdown && !dropdown.contains(event.target)) {
            if (ReactDOM.findDOMNode(this).contains(event.target)) {
                this.setState({ isOpen: !isOpen })
                onClick(event)
            } else {
                this.setState({ isOpen: false })
            }
        }
    }
}

TagGroup.propTypes = propTypes
TagGroup.defaultProps = defaultProps

export default TagGroup
